import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '~/services/security.service';

@Component({
    selector: 'app-unlicensed',
    templateUrl: './unlicensed.component.html',
    styleUrls: ['./unlicensed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnlicensedComponent implements OnInit {

  constructor(
    private router: Router,
    private _securityService: SecurityService
  ) { }

  ngOnInit(): void {
  }

  goBack(): void {
    this.router.navigate(['/']);
  }

  logout(): void {
    if (localStorage.getItem('accessToken')) {
      this._securityService.logout().subscribe();
    }
    this._securityService.removeLocalCredentials();
    localStorage.removeItem('sessionEnded');
    this.router.navigate(['/login']);
  }
}
